/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const signIn = (email, password) =>
  client.post(
    "/staff/signin",
    {
      email,
      password,
    }
  );

const twoFactorAuthentication = (email, access_code) =>
  client.post(
    "/staff/authentication/two-factor",
    {
      email,
      access_code,
    }
  );

const resetPassword = (
  email,
  password,
  confirm_password,
  password_reset_hash
) =>
  client.post(
    "/staff/reset-password",
    {
      email,
      password,
      confirm_password,
      password_reset_hash,
    }
  );

const forgotPassword = (email) =>
  client.post(
    "/staff/forgot-password",
    { email }
  );

const updatePassword = (email, password, confirmPassword, resetHash) =>
  client.post(
    "/staff/password/update-password",
    {
      email,
      password,
      confirm_password: confirmPassword,
      password_reset_hash: resetHash,
    }
  );

export default {
  signIn,
  twoFactorAuthentication,
  forgotPassword,
  updatePassword,
  resetPassword,
};
